module.exports = __webpack_public_path__ + "static/media/CircleOutline.c10eafd2.svg";